import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important untuk cookies session
});

// Response interceptor untuk handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login if unauthorized
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ========== AUTH API ==========
export const authAPI = {
  login: (username, password) =>
    api.post('/login', { username, password }),

  logout: () =>
    api.post('/logout'),

  checkStatus: () =>
    api.get('/status'),
};

// ========== AGENTS API ==========
export const agentsAPI = {
  getAll: (params) =>
    api.get('/agents', { params }),
  delete: (id) =>
    api.delete(`/agents/${id}`),
  updateAlias: (id, alias) =>
    api.patch(`/agents/${id}`, { alias }),
};

// ========== CERTIFICATES API ==========
export const certificatesAPI = {
  getAll: () =>
    api.get('/certificates'),

  download: (certId) =>
    api.get(`/certificates/${certId}/download`, {
      responseType: 'blob'
    }),

  renewDryRun: (certId) =>
    api.post(`/certificates/${certId}/renew`),

  renewLive: (certId) =>
    api.post(`/certificates/${certId}/renew-live`),

  updateNow: (certId) =>
    api.post(`/certificates/${certId}/update-now`),

  delete: (certId) =>
    api.delete(`/certificates/${certId}`),
};

// ========== LOGS API ==========
export const logsAPI = {
  getLogs: (params) =>
    api.get('/logs', { params }),

  deleteLogs: (startDate, endDate) =>
    api.delete('/logs', {
      params: { start_date: startDate, end_date: endDate }
    }),
};

// ========== SETTINGS API ==========
export const settingsAPI = {
  getTelegramConfig: () =>
    api.get('/settings/telegram'),
  saveTelegramConfig: (data) =>
    api.post('/settings/telegram', data),
  getSecurityConfig: () =>
    api.get('/settings/security'),
  saveSecurityConfig: (data) =>
    api.post('/settings/security', data),
  testTelegram: () =>
    api.post('/test-telegram'),
  getBrandingConfig: () =>
    api.get('/settings/branding'),
  saveBrandingConfig: (data) =>
    api.post('/settings/branding', data),
  uploadLogo: (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    return api.post('/settings/branding/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // ... future settings
};

// ========== USERS API ==========
export const usersAPI = {
  getAll: () =>
    api.get('/users'),
  create: (username, password, role) =>
    api.post('/users', { username, password, role }),
  update: (id, data) =>
    api.patch(`/users/${id}`, data),
  delete: (id) =>
    api.delete(`/users/${id}`),
  changePassword: (id, newPassword) =>
    api.patch(`/users/${id}/password`, { new_password: newPassword }),
};

export default api;
